import axiosInstance from "./axiosInstance";

export interface VendorContact {
  publicId: string;
  name: string;
  email: string;
  contactNumber: string;
  department: string;
}

export interface VendorVehicleType {
  publicId: string;
  name: string;
}

export interface VendorVenue {
  publicId: string;
  name: string;
}

export interface Vendor {
  publicId: string;
  name: string;
  code: string;
  priority: string;
  vendorVehicleTypes: VendorVehicleType[];
  isActive: boolean;
  venues: VendorVenue[];
  contacts: VendorContact[];
}

export interface VendorSearchParams {
  Name?: string;
  Priority?: string;
  VehicleTypePublicId?: string;
  VenuePublicId?: string;
  PageNumber?: number;
  PageSize?: number;
}

export interface VendorSearchResponse {
  pageNumber: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  success: boolean;
  message: string;
  data: Vendor[];
  errors: string[];
}

export interface Venue {
  venueId: number;
  venueName: string;
  contactNo: string;
  emailAddress: string;
  description: string;
  timeZone: string | null;
  isActive: boolean;
  publicId: string;
}

export interface CreateVendorContactPayload {
  name: string;
  contactNumber: string;
  email: string;
  department: string;
}

export interface CreateVendorPayload {
  name: string;
  priority: string;
  isActive: boolean;
  vehicleTypePublicIds: string[];
  venuePublicIds: string[];
  contacts: CreateVendorContactPayload[];
}

export interface CreateVendorResponse {
  success: boolean;
  message: string;
  data: Vendor;
  errors: string[];
}

export interface UpdateVendorContactPayload {
  publicId?: string;
  name: string;
  contactNumber: string;
  email: string;
  department: string;
}

export interface UpdateVendorPayload {
  name: string;
  priority: string;
  isActive: boolean;
  vehicleTypePublicIds: string[];
  venuePublicIds: string[];
  contacts: UpdateVendorContactPayload[];
}

export interface GetVendorResponse {
  success: boolean;
  message: string;
  data: Vendor;
  errors: string[];
}

export interface UpdateVendorResponse {
  success: boolean;
  message: string;
  data: Vendor;
  errors: string[];
}

export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const searchVendors = async (
  params: VendorSearchParams = {}
): Promise<VendorSearchResponse> => {
  const res = await axiosInstance.get("/Vendors/search", {
    params,
    headers: getAuthHeader(),
  });

  return res.data;
};

export const getActiveVenues = async (): Promise<Venue[]> => {
  const res = await axiosInstance.get("/Venues", {
    params: {
      onlyActive: true,
    },
  });

  return res.data ?? [];
};

export const createVendor = async (
  payload: CreateVendorPayload
): Promise<CreateVendorResponse> => {
  const res = await axiosInstance.post("/Vendors", payload, {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const getVendor = async (
  publicId: string
): Promise<GetVendorResponse> => {
  const res = await axiosInstance.get(`/Vendors/${publicId}`, {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const updateVendor = async (
  publicId: string,
  payload: UpdateVendorPayload
): Promise<UpdateVendorResponse> => {
  const res = await axiosInstance.put(`/Vendors/${publicId}`, payload, {
    headers: getAuthHeader(),
  });

  return res.data;
};